import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const GlobalSetup = lazy(() => import('.'))

class GlobalSetupWebComponent extends ReactWebComponent {
	override render() {
		return <GlobalSetup />
	}
}

customElements.define('lokalise-global-setup', GlobalSetupWebComponent)
